<template>
  <div v-if="isQuotationPresent">
    <div class="relative bg-white rounded-2xl shadow-md p-6 mx-auto">
      <span :class="['px-4 py-1 rounded-lg font-bold text-xs absolute top-4 right-4', quotationStatus]">
        {{ $t(`${quotation.approvalStatus}`) }}
      </span>
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2">
        <StackedField label="Devis">
          <div class="inline-flex items-center bg-white rounded-sm p-2 border border-gray-200">
            <PaperClipIcon class="shrink-0 h-3 w-3 text-gray-400 mr-1" />
            <span class="text-xs text-gray-900 mr-2 max-w-xs truncate">{{ quotation.fileName }}</span>
            <a
              :href="quotation.url"
              target="_blank"
              rel="noopener noreferrer"
              class="shrink-0 p-1 bg-blue-100 hover:bg-blue-200 text-blue-700 rounded-sm transition-colors duration-200"
            >
              <EyeIcon class="h-3 w-3" />
            </a>
          </div>
        </StackedField>
        <StackedField label="Montant" :value="formatPrice(quotation.repairCost)" />
      </div>
      <button
        class="font-light text-primary hover:text-primary-dark cursor-pointer mt-2"
        @click="openQuotationCostDetails = true"
      >
        Voir les détails
      </button>
      <QuotationCostDetails
        :quotation="quotation"
        :open="openQuotationCostDetails"
        @close="openQuotationCostDetails = false"
      />
    </div>
  </div>
</template>

<script>
import { StackedField, formatPrice, isPresent } from "@estaly/ui";
import { EyeIcon, PaperClipIcon } from "@heroicons/vue/solid";
import QuotationCostDetails from "@/components/claim/details/quotation/QuotationCostDetails.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    StackedField,
    QuotationCostDetails,
    PaperClipIcon,
    EyeIcon,
  },
  props: ["quotation"],

  data() {
    return {
      openQuotationCostDetails: false,
    };
  },

  computed: {
    ...mapGetters("claims", ["quotationStatusClass"]),
    isQuotationPresent() {
      return isPresent(this.quotation);
    },
    quotationStatus() {
      return this.quotationStatusClass(this.quotation.approvalStatus);
    },
  },

  methods: {
    formatPrice,
  },
};
</script>
